import {AfterViewChecked, ChangeDetectorRef, Component, NgZone, OnInit} from '@angular/core';
import {SiteReferenceService} from "../site-reference.service";
import {DeploymentsService} from "../deployments.service";
import {DataService} from "../data.service";
import {ActivatedRoute, Router} from "@angular/router";
import {ErddapService} from "../erddap.service";
import * as moment from 'moment';
import {TimezoneService} from "../timezone.service";
import {NgxSpinnerService} from "ngx-spinner";

@Component({
    selector: 'app-data-download',
    templateUrl: './data-download.component.html',
})
export class DataDownloadComponent implements OnInit, AfterViewChecked {

    deploymentNumber: number | null;

    dataFileFormats = ['.csvp', '.json', '.mat', '.nc', '.xml'];
    metadataFileFormats = ['.csv', '.json', '.nc', '.xml'];
    selectedDataFormat = '.nc';
    selectedMetadataFormat = '.nc';
    ctdVariables = ['time', 'depth', 'latitude', 'longitude', 'conductivity', 'temperature', 'salinity', 'density', 'pressure', 'profile_id'];
    availableCtdVariables: string[] = [];
    selectedVariablesType = 'CTD';
    selectedVariables: { [key: string]: boolean } = {};
    cfStandandardNamesUrl: any = null;


    missions: any = null;
    erddapMetadata: any = null;
    variableLookup: { [key: string]: string } = {};
    selectedMission: any = null;
    wasValidated: any = null;
    selectedMetadata: { delayed: { id: string, variables: string[] } | null, realtime: { id: string, variables: string[] } | null };
    missionHasData: any = null;
    selectedDatasetType: 'Delayed' | 'Realtime';
    dataUrl: string;
    metadataUrl: string;

    //erddapService = ErddapService();
    moment: any = moment;
    timezone: any = null;

    constructor(
        private siteReference: SiteReferenceService,
        private deploymentsService: DeploymentsService,
        private dataService: DataService,
        private route: ActivatedRoute,
        private erddapService: ErddapService,
        private router: Router,
        private zone: NgZone,
        private spinner: NgxSpinnerService,
        private changeDetectorRef: ChangeDetectorRef,
        private timezoneService: TimezoneService) {
        this.timezone = timezoneService.timezone;
        this.cfStandandardNamesUrl = this.siteReference.cfStandandardNamesUrl;
    }

    ngOnInit() {
        this.deploymentsService.getAllDeployments().then(response => {
            this.missions = response.sort((a, b) => b.deployment_number - a.deployment_number);
            this.deploymentsService.getMetadata().then(response => {
                this.erddapMetadata = response;
                this.updateSelectionsForUrl();
                this.updateDownloadUrls();
            });
        });

        this.dataService.getVariableLookup().then(response => {
            this.variableLookup = response;
            setTimeout(function () {
                $('[data-toggle="tooltip"]').tooltip()
            }, 500);
        });

        this.deploymentNumber = parseInt(this.route.snapshot.params['deploymentNumber']);
    }

    ngAfterViewChecked() {
        this.fixLabelCutoffs();
    }

    /**
     * When a variable label is too long and is cut off, add the variable name to the tooltip
     */
    fixLabelCutoffs() {
        document.querySelectorAll('.form-check-label').forEach(label => {
            const variable = <string>label.textContent;
            if ((<HTMLElement>label).offsetWidth < label.scrollWidth) {
                if (!this.variableLookup[variable]) {
                    this.variableLookup[variable] = variable;
                } else if (!this.variableLookup[variable].includes(variable)) {
                    this.variableLookup[variable] = variable + ': ' + this.variableLookup[variable];
                }
            }
        });
        this.changeDetectorRef.detectChanges();
    }

    updateSelectionsForUrl() {
        this.wasValidated = false;

        if (this.deploymentNumber) {
            var index = Array.indexOfByProperty(this.missions, this.deploymentNumber, 'deployment_number');
            if (index >= 0) {
                this.selectedMission = this.missions[index];
            }

            this.selectedMetadata = this.erddapMetadata[this.deploymentNumber];
            this.missionHasData = this.selectedMetadata.delayed || this.selectedMetadata.realtime;
            if (this.missionHasData) {
                // if delayed is available, select it, otherwise select realtime
                if (this.selectedMetadata.delayed) {
                    this.selectedDatasetType = 'Delayed';
                } else if (this.selectedMetadata.realtime) {
                    this.selectedDatasetType = 'Realtime';
                }
                // select which variables are available
                if (this.selectedDatasetType == 'Delayed' && this.selectedMetadata.delayed && this.selectedMetadata.delayed.variables) {
                    this.selectedMetadata.delayed.variables.forEach(variable => {
                        if (!this.selectedVariables.hasOwnProperty(variable) && this.ctdVariables.includes(variable)) {
                            this.selectedVariables[variable] = this.ctdVariables.indexOf(variable) >= 0;
                        }
                    });
                    // only provide CTD variables that are available
                    this.availableCtdVariables = this.ctdVariables.filter(v => this.selectedMetadata.delayed?.variables.includes(v));
                } else if (this.selectedDatasetType == 'Realtime' && this.selectedMetadata.realtime && this.selectedMetadata.realtime.variables) {
                    this.selectedMetadata.realtime.variables.forEach(variable => {
                        if (!this.selectedVariables.hasOwnProperty(variable) && this.ctdVariables.includes(variable)) {
                            this.selectedVariables[variable] = this.ctdVariables.indexOf(variable) >= 0;
                        }
                    });
                    // only provide CTD variables that are available
                    this.availableCtdVariables = this.ctdVariables.filter(v => this.selectedMetadata.realtime?.variables.includes(v));
                }
            }
        } else {
            this.selectedMission = null;
            this.selectedVariables = {};
        }
    }

    updateDownloadUrls() {
        if (!this.selectedMission || !this.selectedDatasetType || !this.selectedVariablesType) {
            return;
        }

        let selectedVariables: string[];
        if (this.selectedVariablesType == 'Custom') {
            if (this.selectedDatasetType == 'Delayed' && this.selectedMetadata.delayed) {
                selectedVariables = this.selectedMetadata.delayed.variables.filter(variable => this.selectedVariables[variable] == true);
            } else if (this.selectedDatasetType == 'Realtime' && this.selectedMetadata.realtime) {
                selectedVariables = this.selectedMetadata.realtime.variables.filter(variable => this.selectedVariables[variable] == true);
            } else {
                throw new TypeError('Selected dataset type is unavailable');
            }
        } else if (this.selectedVariablesType == 'CTD') {
            selectedVariables = ([] as string[]).concat(this.ctdVariables);
        } else {
            throw new TypeError(`Unrecognized selectedVariablesType ${this.selectedVariablesType}, should be Custom or CTD`);
        }

        let datasetId: any;
        if (this.selectedDatasetType == 'Delayed' && this.selectedMetadata.delayed) {
            datasetId = this.selectedMetadata.delayed.id;
        } else if (this.selectedDatasetType == 'Realtime' && this.selectedMetadata.realtime) {
            datasetId = this.selectedMetadata.realtime.id;
        }

        this.dataUrl = this.erddapService.generateDataUrl(datasetId, selectedVariables, this.selectedDataFormat);
        this.metadataUrl = this.erddapService.generateMetadataUrl(datasetId, this.selectedMetadataFormat);
    }

    downloadData(form) {
        this.wasValidated = true;
        if (!form.valid) {
            return;
        }

        this.updateDownloadUrls(); // Sanity check in case of preview update defect

        window.location.href = this.dataUrl;
    }

    downloadMetadata(form) {
        this.wasValidated = true;
        if (!form.valid) {
            return;
        }

        this.updateDownloadUrls(); // Sanity check in case of preview update defect

        window.location.href = this.metadataUrl;
    }

}
